import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'reset-css'
import './assets/font/iconfont.css'
import './assets/style/media.less'
import 'element-ui/lib/theme-chalk/index.css'
import '@/mixins/routerMixins';

import Element from 'element-ui'
Vue.use(Element)
// 自定义指令
import directive from '@/directive/index'
Object.keys(directive).forEach(key => {
  Vue.directive(key, directive[key])
})

import jquery from 'jquery'
window.jquery = window.Jquery = window.$ = jquery;

// 全局EventBus
Vue.prototype.$EventBus = new Vue();
import './permission';

Vue.config.productionTip = false
// 自定义弹层抽象组件
import AbstractDialog from '@/abstract/dialog/implementation';
Vue.component('AbstractDialog', AbstractDialog);
import DefaultPortia from '@/components/layout/portia';
Vue.component('portia', DefaultPortia);

import defaultSetting from '@/setting/index';
Vue.$defaultSetting = Vue.prototype.$defaultSetting = defaultSetting;


//引入
import moment from 'moment';
//挂载到原型
Vue.prototype.$moment = moment ;
//汉化，否则显示日期格式是国外的日期格式
moment.locale("zh-CN");


// 重写vue-elementui 的$message
Vue.$message = Vue.prototype.$message = {
  error: (msg) => {
    if (msg !== 'ResponseError') {
      Element.Message.error(msg);
    }
  },
  success: (msg) => {
    Element.Message.success(msg);
  }
}
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
